module.exports = __webpack_public_path__ + "static/media/play.79496f8b.svg";